import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcSliderComponent} from './ac-slider.component';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {InfraPipesModule} from "../../pipes/infra.pipes.module";
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgxSliderModule,
        MatSlideToggleModule,
        FormsModule,
        InfraPipesModule
    ],
    declarations: [
        AcSliderComponent,
    ],
    exports: [
        AcSliderComponent,
    ]
})
export class AcSliderModule {
}
